const toPercent = value => Math.round(value * 100)
const toDollars = value => Math.round(value)

const BENCHMARK_METRIC_DEFINITIONS = [
  {
    id: 'revenue-per-student',
    label: 'Revenue per student',
    description:
      'Lesson take-home over the last 12 months for each active student',
    unit: 'currency',
    coachKey: 'arpsDollars',
    peerKey: 'medianArpsDollars',
    format: toDollars,
    gettingStartedValue: 100,
    top10Value: 450,
    insightBody:
      'Top lesson coaches earn more from each student they teach. Packs and group sessions lift revenue per student without adding hours to your week.',
    insightTip:
      'What top coaches do: Offer a lesson pack at the end of the first lesson and run one weekly group clinic.',
  },
  {
    id: 'student-retention',
    label: 'Student retention',
    description:
      'Students from the prior 90 days who came back in the last 90 days',
    unit: 'percent',
    coachKey: 'retention90d',
    peerKey: 'medianRetention90d',
    format: toPercent,
    gettingStartedValue: 15,
    top10Value: 70,
    insightBody:
      'Students who book again within a few weeks tend to stay. Making the next lesson easy to book is the biggest lever on retention.',
    insightTip:
      'What top coaches do: Offer two specific times for the next lesson before the student leaves, and follow up within 24 hours.',
  },
  {
    id: 'lesson-pack-attach',
    label: 'Students with lesson packs',
    description: 'Share of your active students with a lesson pack',
    unit: 'percent',
    coachKey: 'packAttachRate',
    peerKey: 'medianPackAttach',
    format: toPercent,
    gettingStartedValue: 20,
    top10Value: 95,
    insightBody:
      'Students with a lesson pack book more often and stay longer. Offering a pack up front is the simplest way to commit a student to a series.',
    insightTip:
      'What top coaches do: Offer a 5- or 10-lesson pack at the first booking and again after the second lesson.',
  },
]

const hasValue = value => typeof value === 'number'

export const buildBenchmarkMetrics = bottleneck => {
  const { you, peers } = bottleneck ?? {}

  if (!you || !peers) {
    return []
  }

  return BENCHMARK_METRIC_DEFINITIONS.filter(
    ({ coachKey, peerKey }) =>
      hasValue(you[coachKey]) && hasValue(peers[peerKey]),
  ).map(({ coachKey, peerKey, format, ...definition }) => ({
    ...definition,
    coachValue: format(you[coachKey]),
    medianValue: format(peers[peerKey]),
    higherIsBetter: true,
  }))
}

export default buildBenchmarkMetrics
